import { FC } from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';
import {
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';

import { Channel, CHANNELS } from 'types/customer';
import { ChannelFormBase } from '../../FormBases';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
  watchChannel: Channel;
  error: FieldError | undefined;
};

/**
 * 編集モーダル用の契約種別フォームです。
 */
export const ChannelForm: FC<Props> = ({ register, watchChannel, error }) => (
  <FormControl isRequired isInvalid={Boolean(error)}>
    <SimpleGrid templateColumns="1fr 2fr">
      <FormLabel>契約種別</FormLabel>
      <Box>
        <ChannelFormBase register={register} />
        {watchChannel === CHANNELS.BETA && (
          <Box mt="10px" ml="10px">
            <Text color="red">※ β版には不具合が含まれる場合があります。</Text>
          </Box>
        )}
      </Box>
    </SimpleGrid>
    <FormErrorMessage>{error && error.message}</FormErrorMessage>
  </FormControl>
);
